import { Component } from '@angular/core';

@Component({
  selector: 'bt-settings',
  standalone: false,
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent {

}
